import React from 'react';
import { CandidateProfileProvider } from 'candidate_profile_redesign/store/use_candidate_profile';
import { useCandidateProfileProps } from 'talent_matching/api';

interface WrapperProps {
  candidateProfileContextPath: string;
  children: React.ReactNode;
}

// To reuse candidate profile modals we need to wrap them in a candidate profile provider
// This is because internally the modals use the candidate profile store

const CandidateProfileWrapper: React.FC<WrapperProps> = ({
  candidateProfileContextPath,
  children,
}) => {
  const { data: candidateProfileProps, isLoading } = useCandidateProfileProps(
    candidateProfileContextPath
  );

  if (isLoading || !candidateProfileProps) {
    return null; // Or a loading spinner
  }

  return (
    <CandidateProfileProvider {...candidateProfileProps}>
      {children}
    </CandidateProfileProvider>
  );
};

export default CandidateProfileWrapper;
